import { Heading, Text, VStack } from '@ayble-health/dashboard-components';
import { Box, Flex } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import { FoodCard } from './FoodCard';
import { Loader } from '../../Loader';
import { useTrackableFoods } from '../../../api/healthCoach/useTrackableFoods';

export const TrackableFoods = () => {
  const { patient } = useParams();
  const { error, foods, isLoading } = useTrackableFoods(patient);

  if (isLoading) {
    return (
      <Box p={0}>
        <Loader loading={true} />
      </Box>
    );
  }

  if (error) {
    return (
      <Text color={'red.500'}>
        Error while loading the trackable food categories. Please try again
        later or contact support.
      </Text>
    );
  }

  const foodsCount = foods?.length ?? 0;
  const subTitle = `${foodsCount} food${foodsCount === 1 ? '' : 's'}`;

  return (
    <VStack>
      <Heading fontWeight={'normal'} size={'md'} textAlign="left">
        Trackable food categories
      </Heading>

      <Text mb={6}>{subTitle}</Text>

      <Box>
        <Flex flexDir={'row'} overflow={'scroll'} pb={4}>
          {foods?.map(({ category, id, image_url, name }) => (
            <FoodCard
              disableSeverityColor
              severityLabel={category}
              foodId={id}
              foodLabel={name}
              imgURL={image_url ?? ''}
              key={id}
            />
          ))}
        </Flex>
      </Box>
    </VStack>
  );
};
